<template>
    <div class="search-results-res">
        {{ getSummary }}
    </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import {checkIfHasHash} from '@/plugins/utils';
const {mapGetters} = createNamespacedHelpers('searchresults');
export default {
    name: "ResultsSummary",
    computed: {
        ...mapGetters([
            'getSearchResultsField'
        ]),
        getSummary() {
            let summary =  this.getSearchResultsField('total').toLocaleString() + ' results found ';
            const hasHash = checkIfHasHash(this.getSearchResultsField('summary'));
            if(this.getSearchResultsField('summary') && !hasHash) {
                summary += 'for "' + this.getSearchResultsField('summary') + '"';
            }
            return summary;
        }
    },
    methods: {
        checkIfHasHash
    }
}
</script>
